import { useEffect } from "react";

// ─────────────────────────────────────────────────────────────────────────────
// EditBridge — Site "/?edit=1" ile yüklendiğinde (Görsel Editör iframe'i içinde)
// çalışır. Bölümlerin (data-edit) üzerine gelince çerçeve gösterir, tıklayınca
// üst pencereye (Görsel Editör) hangi bölümün seçildiğini bildirir.
// ─────────────────────────────────────────────────────────────────────────────
export default function EditBridge() {
  useEffect(() => {
    document.documentElement.setAttribute("data-cc-edit", "1");

    const style = document.createElement("style");
    style.textContent = `
      [data-cc-edit] [data-edit]{ cursor:pointer !important; transition:outline-color .12s; }
      [data-cc-edit] [data-edit].cc-hover{ outline:2px dashed #3B82F6; outline-offset:-2px; }
      [data-cc-edit] [data-edit].cc-active{ outline:3px solid #3B82F6; outline-offset:-3px; }
      .cc-edit-badge{
        position:fixed; z-index:2147483647; pointer-events:none;
        background:#2563EB; color:#fff; font:600 12px/1 system-ui,sans-serif;
        padding:6px 10px; border-radius:8px; box-shadow:0 6px 18px rgba(0,0,0,.25);
        transform:translateY(-100%); white-space:nowrap;
      }
    `;
    document.head.appendChild(style);

    const badge = document.createElement("div");
    badge.className = "cc-edit-badge";
    badge.style.display = "none";
    document.body.appendChild(badge);

    let hovered: HTMLElement | null = null;
    let active: HTMLElement | null = null;

    const labelOf = (el: HTMLElement) => el.getAttribute("data-edit") || "";

    const onMove = (e: MouseEvent) => {
      const el = (e.target as HTMLElement)?.closest?.("[data-edit]") as HTMLElement | null;
      if (el !== hovered) {
        hovered?.classList.remove("cc-hover");
        hovered = el;
        if (el) el.classList.add("cc-hover");
      }
      if (el) {
        badge.textContent = labelOf(el);
        badge.style.display = "block";
        const r = el.getBoundingClientRect();
        badge.style.left = Math.max(8, r.left + 6) + "px";
        badge.style.top = Math.max(22, r.top - 4) + "px";
      } else {
        badge.style.display = "none";
      }
    };

    // Edit modunda tüm tıklamalar seçim içindir — gezinme yok.
    const onClick = (e: MouseEvent) => {
      const el = (e.target as HTMLElement)?.closest?.("[data-edit]") as HTMLElement | null;
      e.preventDefault();
      e.stopPropagation();
      if (!el) return;
      if (active) active.classList.remove("cc-active");
      active = el;
      el.classList.add("cc-active");
      window.parent?.postMessage({ type: "cc-edit-select", section: labelOf(el) }, "*");
    };

    const onMsg = (e: MessageEvent) => {
      const d = e.data;
      if (!d || typeof d !== "object") return;
      if (d.type === "cc-edit-scrollTo" && d.section) {
        const el = document.querySelector(`[data-edit="${d.section}"]`) as HTMLElement | null;
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          if (active) active.classList.remove("cc-active");
          active = el;
          el.classList.add("cc-active");
        }
      }
    };

    document.addEventListener("mousemove", onMove, true);
    document.addEventListener("click", onClick, true);
    window.addEventListener("message", onMsg);
    window.parent?.postMessage({ type: "cc-edit-ready" }, "*");

    return () => {
      document.removeEventListener("mousemove", onMove, true);
      document.removeEventListener("click", onClick, true);
      window.removeEventListener("message", onMsg);
      document.documentElement.removeAttribute("data-cc-edit");
      style.remove();
      badge.remove();
    };
  }, []);

  return null;
}
